import { createSlice } from '@reduxjs/toolkit';

const navbarSlice = createSlice({
  name: 'navbar',
  initialState: {
    isCollapsed: false,
    activeStatus: null,
  },
  reducers: {
    setNavbarCollapsed: (state, action) => {
      state.isCollapsed = action.payload;
    },
    setActiveStatus: (state, action) => {
      state.activeStatus = action.payload;
    },
  },
});

export const { setNavbarCollapsed, setActiveStatus } = navbarSlice.actions;
export default navbarSlice.reducer;
